import React, { ReactNode } from 'react';

type ButtonProps = {
  children: ReactNode;
  className?: string;
  isFullSized?: boolean;
  trianglesColorClass?: string;
  notAnimated: boolean,
  type?: 'button' | 'submit' | 'reset';
  ariaLabel?: string;
onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const Button = ({
  children,
  notAnimated = false,
  isFullSized = true,
  type = 'button',
  className = '',
  trianglesColorClass = 'bg-beige',
  ariaLabel = '',
  onClick,
}: ButtonProps) => {
  return (
    <button
    aria-label={ariaLabel}
      type={type}
      onClick={onClick}
      className={`${isFullSized
          ? ' text-btn-big px-[3.2rem]  py-[1.4rem]'
          : 'text-btn px-[1.2rem] md:px-[3.2rem] md:py-[1.4rem] py-[0.8rem]'
        } ${className} group hover:bg-dusty-blue hover:text-white gap-[1.2rem] ${notAnimated ? '' : 'hover:gap-[2.5rem]'}  flex transition-[gap,background-color,color] duration-300 ease-in-out cursor-pointer relative text-nowrap items-center justify-center bg-dusty-green`}
    >
      {children}

      <span
        className={`absolute scale-[1.01] hidden lg:block h-full polygon-animated ${notAnimated ? 'lg:hidden' : 'lg:block'} aspect-square right-[3rem] top-0 ${trianglesColorClass}`}
      ></span>
    </button>
  );
};

export default Button;